module.exports = __webpack_public_path__ + "static/media/beach2380.70ae0bfa.jpg";